import { __awaiter, __generator } from "tslib";
import { createDeprecatedInputDriver } from '../../drivers';
import { TimeInputKey } from '..';
import { Simulate } from 'react-dom/test-utils';
export var createTimeInputDriver = function (wrapper) {
    var base = wrapper.$("." + TimeInputKey);
    return {
        getTime: function () { return createDeprecatedInputDriver(wrapper).value(); },
        enterTime: function (val) { return __awaiter(void 0, void 0, void 0, function () {
            var inputDriver, inputElem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        inputDriver = createDeprecatedInputDriver(wrapper);
                        return [4 /*yield*/, inputDriver.enterValue(val)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, base.$('input').getNative()];
                    case 2:
                        inputElem = _a.sent();
                        Simulate.blur(inputElem);
                        return [2 /*return*/];
                }
            });
        }); },
        getPeriod: function () { return base.$('.period').text(); },
        clickPeriod: function () { return base.$('.period').click(); },
        selectOption: function (idx) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, base.$('.toggle-options-button').click()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, base.$$('.time-options-menu .time-option').get(idx).click()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        exists: function () { return base.exists(); },
    };
};
//# sourceMappingURL=time-input.driver.js.map